import { render, staticRenderFns } from "./BCard.vue?vue&type=template&id=840c6cb8"
import script from "./BCard.vue?vue&type=script&lang=js"
export * from "./BCard.vue?vue&type=script&lang=js"
import style0 from "./BCard.vue?vue&type=style&index=0&id=840c6cb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports